module.exports = __webpack_public_path__ + "img/applemap.8d437b14.png";